import { objectKeys } from "app/helpers/objects";
import type { ColumnsConfigType } from "app/pages/sales-intelligence/modules/enrichment/store/type";
import { createColumnCategoriesConfig } from "app/pages/sales-intelligence/modules/leads-search/configuration/columns/categories";
import type { LeadsColumnCategoryDto } from "app/pages/sales-intelligence/modules/leads-search/types";

import { CONTACTS_COLUMN_CATEGORY_CONFIG } from "../../constants/columns";
import type { CsvExportColumnCategory, CsvExportColumnOptions } from "../../types/columns";

import type { IColumnsExportService } from "./types";

export const createColumnsExportService = (): IColumnsExportService => {
    const leadsExportCategoryOrder: readonly LeadsColumnCategoryDto[] = [
        "companyAndWebsite",
        "technologies",
        "incomingTraffic",
        "visitorsAndEngagement",
        "marketingChannels",
        "apps",
        "adSpend",
    ];

    const contactsExportCategoryOrder: readonly CsvExportColumnCategory[] = ["contacts", "companyAndWebsite"];

    const sortCategoriesByOrder = (
        categories: readonly ColumnsConfigType[],
        order: readonly string[],
    ): readonly ColumnsConfigType[] => {
        return [...categories].sort((a, b) => {
            const indexA = order.indexOf(a.name);
            const indexB = order.indexOf(b.name);

            const orderA = indexA === -1 ? order.length : indexA;
            const orderB = indexB === -1 ? order.length : indexB;

            return orderA - orderB;
        });
    };

    return {
        buildLeadsConfig(columnsData: CsvExportColumnOptions): readonly ColumnsConfigType[] {
            const categoriesConfig = createColumnCategoriesConfig();

            const categories = objectKeys(columnsData.leads).map((categoryId) => {
                const { name, labelKey } = categoriesConfig.getCategoryConfig(categoryId);

                return {
                    name,
                    labelKey,
                    fields: columnsData.leads[name],
                };
            });

            return sortCategoriesByOrder(categories, leadsExportCategoryOrder);
        },

        buildContactsConfig(columnsData: CsvExportColumnOptions): readonly ColumnsConfigType[] {
            const categoriesConfig = createColumnCategoriesConfig();

            const categories = objectKeys(columnsData.contacts).map((categoryId) => {
                let name: CsvExportColumnCategory;
                let labelKey: string;

                if (categoryId === "contacts") {
                    ({ name, labelKey } = CONTACTS_COLUMN_CATEGORY_CONFIG);
                } else {
                    ({ name, labelKey } = categoriesConfig.getCategoryConfig(categoryId));
                }

                return {
                    name,
                    labelKey,
                    fields: columnsData.contacts[name],
                };
            });

            return sortCategoriesByOrder(categories, contactsExportCategoryOrder);
        },
    };
};
